import { render, staticRenderFns } from "./DashboardUserInfo.vue?vue&type=template&id=22050e9a&scoped=true&"
import script from "./DashboardUserInfo.vue?vue&type=script&lang=js&"
export * from "./DashboardUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserInfo.vue?vue&type=style&index=0&id=22050e9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22050e9a",
  null
  
)

export default component.exports